<div
  class="form-group m-0 w-100"
  [class.dropdown-open]="isOpen"
  [class.no-label]="!placeholder">

  <div class="dropdown-control">
    <button
      #toggleButton
      type="button"
      class="form-select w-100 d-flex align-items-center"
      [class.error]="isInvalid()"
      [class.selected]="!!selectedItem"
      [id]="buttonId"
      [attr.aria-label]="ariaLabel || placeholder"
      [attr.aria-controls]="menuId"
      [attr.aria-expanded]="isOpen"
      [attr.data-testid]="testId"
      [attr.disabled]="disabled ? '' : null"
      aria-haspopup="listbox"
      (click)="toggle()"
      (keydown.arrowdown)="onToggleArrowKey($any($event), false)"
      (keydown.arrowup)="onToggleArrowKey($any($event), true)">

      <span class="dropdown-value text-truncate">
        {{ resolveName(selectedItem) }}
      </span>
    </button>

    @if (placeholder) {
      <label
        class="form-label"
        [attr.for]="buttonId">
        {{ placeholder }}
      </label>
    }

    <div class="d-flex align-items-center form-action">
      <span
        class="dropdown-arrow"
        [class.open]="isOpen"
        aria-hidden="true">
      </span>
    </div>
  </div>

  <ul
    #dropdownMenu
    class="dropdown-options"
    popover="manual"
    role="listbox"
    [id]="menuId"
    [attr.aria-labelledby]="buttonId"
    (keydown)="onMenuKeydown($any($event))">

    @for (item of items; track getValue(item)) {
      <li>
        <button
          type="button"
          class="dropdown-option w-100 text-left"
          role="option"
          [attr.aria-selected]="isSelected(item)"
          [attr.data-testid]="testId ? testId + '-' + resolveName(item) : null"
          (click)="onItemClick(item)">
          {{ resolveName(item) }}
        </button>
      </li>
    }
  </ul>
</div>

@if (!isInvalid()) {
  <div class="hint mt-kh-1 pl-kh-2">
    <ng-content select="[hint]"></ng-content>
  </div>
} @else {
  <div class="mt-kh-1 pl-kh-2">
    @for (error of getErrorMessages(control?.errors ?? null); track error) {
      <div
        class="kh-small-text kh-text-error"
        data-testid="error-message">
        {{ error }}
      </div>
    }
  </div>
}
